import * as yup from 'yup';

const eventsApiResponseItemSchema = yup.object({
	source: yup.string().required(),
	events: yup.array().required(),
	hasMore: yup.boolean().required(),
	offset: yup.number().required(),
	total: yup.number().required(),
});

export const eventsApiResponseSchema = yup
	.object()
	.test('validate-numeric-keys', 'Invalid structure in one or more data blocks', function (value) {
		if (typeof value !== 'object' || value === null) return false;

		for (const key of Object.keys(value)) {
			if (!/^\d+$/.test(key)) continue; // Skip non-numeric keys like "events-calendar-plus-version"

			try {
				eventsApiResponseItemSchema.validateSync(value[key]);
			} catch (err) {
				console.error(`Invalid entry at key "${key}":`, err);
				return false;
			}
		}

		return true;
	});
